import React, { useState, useEffect, useContext } from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { UserContext } from "../context/UserContext";
import "../styles/Admin.css";

function AdminLayout() {
    const navigate = useNavigate();
    const location = useLocation();
    const { user, fetchUser } = useContext(UserContext);
    const [menuOpen, setMenuOpen] = useState(false);

    useEffect(() => {
        const checkAccess = async () => {
            if (!user) {
                await fetchUser();
            }
        };
        checkAccess();
    }, [user, fetchUser]);

    useEffect(() => {
        // بررسی هر دو مقدار admin و isAdmin
        if (user && !user.admin && !user.isAdmin) {
            alert("You are not authorized to access the Admin Panel.");
            navigate("/auth");
        } else if (user && location.pathname === "/Admin") {
            navigate("/Admin/Users");
        }
    }, [user, location, navigate]);

    if (!user) return null;

    return (
        <div className="admin-container">
            <button className="menu-button" onClick={() => setMenuOpen(!menuOpen)}>
                ☰
            </button>

            <div className={`admin-sidebar ${menuOpen ? "open" : ""}`}>
                <h2>🔧 Admin Panel</h2>
                <ul>
                    <li className={location.pathname === "/Admin/Users" ? "active" : ""} onClick={() => { navigate("/Admin/Users"); setMenuOpen(false); }}>👤 Users</li>
                    <li className={location.pathname === "/Admin/Chatrequests" ? "active" : ""} onClick={() => navigate("/Admin/Chatrequests")}>📊 Chat Requests</li>
                    <li className={location.pathname === "/Admin/Imagerequests" ? "active" : ""} onClick={() => navigate("/Admin/Imagerequests")}>📊 Image Requests</li>
                </ul>
            </div>

            <div className="admin-content">
                <Outlet />
            </div>
        </div>
    );
}

export default AdminLayout;